// 导入组件
import Vue from 'vue';
import Router from 'vue-router';
// 测试 视频

import video from '@/views/other/video3';


// 登录
import login from '@/views/login/login_00000';
import adminLogin from '@/views/login/adminLogin';
import adminLogin69 from '@/views/login/adminLogin69';
// admin69独享
import adminIndex69 from '@/views/admin69/index';
// 给金威单独定制首页
// import login from '@/views/login/login_10008';
import adminIndex from '@/views/admin666/index';


// 移动端登录 
import mobileLogin from '@/views/login/mobileLogin';

// 首页
import index from '@/views/login/Home.vue';
import index2 from '@/views/login/Home2.vue';

// 卡片
import card from '@/views/login/card';
// 抖音卡片
import dyc from '@/views/login/dyC';

// 验证
import verification from '@/views/outReport/verification10203';
import DocVerification from '@/views/outReport/DocVerification';

import outReport from '@/views/outReport/outReport';

// 启用路由
Vue.use(Router);
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

// 导出路由 
export default new Router({
    routes: [
        {
            path: '/',
            name: 'login',
            component: login,
            hidden: true,
            meta: {
                requireAuth: false
            }
        },

        {
            path: '/video',
            name: 'video',
            component: video,
            hidden: true,
            meta: {
                requireAuth: false
            }
        },

        {
            path: '/admin666',
            name: 'adminLogin',
            component: adminLogin,
            hidden: true,
            meta: {
                requireAuth: false
            }
        },

        {
            path: '/admin69',
            name: 'adminLogin69',
            component: adminLogin69,
            hidden: true,
            meta: {
                requireAuth: false
            }
        },

        {
            path: '/mobileLogin',
            name: 'mobileLogin',
            component: mobileLogin,
        },

        {
            path: '/adminIndex',
            name: 'adminIndex',
            component: adminIndex,
        },

        {
            path: '/adminIndex69',
            name: 'adminIndex69',
            component: adminIndex69,
        },

        // {
        //     path: '/UDPTest',
        //     name: '通用扫码',
        //     component: resolve => require(['../views/UDP.vue'], resolve),
        //     meta: {
        //         keepAlive: true
        //     }
        // },
        // 移动端404
        {
            path: '/mobile404',
            name: '404',
            component: resolve => require(['../views/mobile/process/mobile404.vue'], resolve),
            meta: {
                keepAlive: true
            }
        },

        {
            path: '/simpleBarcode',
            name: '通用扫码',
            component: resolve => require(['../views/mobile/barcode/simpleBarcode/simpleBarcode.vue'], resolve),
            meta: {
                keepAlive: true
            }
        },

        {
            path: '/companyBarcode',
            name: '扫码预约',
            component: resolve => require(['../views/mobile/barcode/barcodeLogin/companyBarcode.vue'], resolve),
            meta: {
                keepAlive: true
            }
        },


        // 扫码预约定制10948*****************************************************************************************************************
        {
            path: '/companyBarcode10948_1',
            name: '扫码预约',
            component: resolve => require(['../views/mobile/barcode/barcodeLogin/companyBarcode10948_1.vue'], resolve),
            meta: {
                keepAlive: true
            }
        },

        {
            path: '/companyBarcode10948_2',
            name: '扫码预约',
            component: resolve => require(['../views/mobile/barcode/barcodeLogin/companyBarcode10948_2.vue'], resolve),
            meta: {
                keepAlive: true
            }
        },


        {
            path: '/ApplyInfo10948_1',
            name: 'ApplyInfo10948_1',
            component: resolve => require(['../views/mobile/barcode/barcodeLogin/ApplyInfo10948_1.vue'], resolve),
        },

         {
            path: '/ApplyInfo10948_2',
            name: 'ApplyInfo10948_2',
            component: resolve => require(['../views/mobile/barcode/barcodeLogin/ApplyInfo10948_2.vue'], resolve),
        },


        // 扫码预约定制10948*****************************************************************************************************************

        {
            path: '/barcodeLogin',
            name: '登录扫码预约',
            component: resolve => require(['../views/mobile/barcode/barcodeLogin/barcodeLogin.vue'], resolve),
        },

        {
            path: '/goodsLogin',
            name: 'goodsLogin',
            component: resolve => require(['../views/mobile/GoodsConfirm/goodsLogin.vue'], resolve),
        },

        {
            path: '/barcodeLoginNew',
            name: 'barcodeLoginNew',
            component: resolve => require(['../views/mobile/barcode/barcodeLogin/barcodeLoginNew.vue'], resolve),
        },

        {
            path: '/companyBarcodeNew',
            name: 'companyBarcodeNew',
            component: resolve => require(['../views/mobile/barcode/barcodeLogin/companyBarcodeNew.vue'], resolve),
        },

        //   {
        //     path: '/QRcode2',
        //     name: 'QRcode2',
        //     component: resolve => require(['../views/mobile/QRcode/QRcode2.vue'], resolve),
        // },

        {
            path: '/QRcode',
            name: 'QRcode',
            component: resolve => require(['../views/mobile/QRcode/QRcode.vue'], resolve),
        },

        {
            path: '/companyLogin',
            name: 'companyLogin',
            component: resolve => require(['../views/mobile/manage/companyLogin.vue'], resolve),
        },

        {
            path: '/ApplyInfo',
            name: 'ApplyInfo',
            component: resolve => require(['../views/mobile/barcode/barcodeLogin/ApplyInfo.vue'], resolve),
        },

        {
            path: '/companyWeightList',
            name: 'companyWeightList',
            component: resolve => require(['../views/mobile/barcode/barcodeLogin/companyWeightList.vue'], resolve),
        },

        {
            path: '/ConfirmList',
            name: 'ConfirmList',
            component: resolve => require(['../views/mobile/GoodsConfirm/ConfirmList.vue'], resolve),
        },


        {
            path: '/weightList',
            name: 'weightList',
            component: resolve => require(['../views/mobile/weightCloud/weightList.vue'], resolve),
        },


        {
            path: '/weightDetails',
            name: 'weightDetails',
            component: resolve => require(['../views/mobile/weightCloud/weightDetails.vue'], resolve),
        },



        {
            path: '/userManage',
            name: 'userManage',
            component: resolve => require(['../views/mobile/manage/mine/userManage.vue'], resolve),
            meta: {
                keepAlive: true
            },
        },


        {
            path: '/reportList',
            name: 'reportList',
            component: resolve => require(['../views/mobile/weightReport/reportList.vue'], resolve),
            meta: {
                keepAlive: true
            },
        },

        {
            path: '/dataSummary',
            name: 'dataSummary',
            component: resolve => require(['../views/mobile/weightReport/dataSummary.vue'], resolve),
            meta: {
                keepAlive: true
            },
        },

        {
            path: '/rechargeSummary',
            name: 'moveRechargeSummary',
            component: resolve => require(['../views/mobile/weightReport/rechargeSummary.vue'], resolve),
            meta: {
                keepAlive: true
            },
        },


        {
            path: '/historySummary',
            name: 'historySummary',
            component: resolve => require(['../views/mobile/weightReport/historySummary.vue'], resolve),
            meta: {
                keepAlive: true
            },
        },

        {
            path: '/timerReport',
            name: 'timerReport',
            component: resolve => require(['../views/mobile/weightReport/timerReport.vue'], resolve),
            meta: {
                keepAlive: true
            },
        },

        {
            path: '/carManage',
            name: 'carManage',
            component: resolve => require(['../views/mobile/manage/mine/carManage.vue'], resolve),
            meta: {
                keepAlive: true
            },
        },

        {
            path: '/goodPriceManage',
            name: 'goodPriceManage',
            component: resolve => require(['../views/mobile/manage/mine/goodPriceManage.vue'], resolve),
            meta: {
                keepAlive: true
            },
        },

        {
            path: '/examine',
            name: 'examine',
            component: resolve => require(['../views/mobile/manage/mine/examine.vue'], resolve),
        },

        {
            path: '/accountManage',
            name: 'moveAccountManage',
            component: resolve => require(['../views/mobile/manage/mine/accountManage.vue'], resolve),
        },

        {
            path: '/unitManage',
            name: 'moveUnitManage',
            component: resolve => require(['../views/mobile/manage/mine/unitManage.vue'], resolve),
        },

        {
            path: '/examineNew',
            name: 'examineNew',
            component: resolve => require(['../views/mobile/manage/mine/examineNew.vue'], resolve),
        },

        {
            path: '/addAccount',
            name: 'addAccount',
            component: resolve => require(['../views/mobile/manage/mine/addAccount.vue'], resolve),
        },




        {
            path: '/error',
            name: 'error',
            component: resolve => require(['../components/error.vue'], resolve),
            hidden: true,
            meta: {
                requireAuth: false
            }
        },
        {
            path: '/wsc',
            name: 'wsc',
            component: card,
            hidden: true,
            meta: {
                requireAuth: false
            }
        },
        {
            path: '/dyc',
            name: 'dyc',
            component: dyc,
            hidden: true,
            meta: {
                requireAuth: false
            }
        },
        {
            path: '/verification',
            name: '验证',
            component: verification,
            hidden: true,
            meta: {
                requireAuth: false
            }
        },

        {
            path: '/DocVerification',
            name: '验证页面',
            component: DocVerification,
            hidden: true,
            meta: {
                requireAuth: false
            }
        },

        {
            path: '/outReport',
            name: '验证2',
            component: outReport,
            hidden: true,
            meta: {
                requireAuth: false
            }
        },


        {
            path: '/home2',
            name: '云称重模块',
            component: index2,
            iconCls: 'el-icon-tickets',
            children: [
                // {
                //     path: '/cloudWeight/weightIndex',
                //     name: '用户管理',
                //     component: resolve => require(['../views/cloudWeight/weightIndex/index.vue'], resolve),
                //     meta: {
                //         index: '/cloudWeight/weightIndex',
                //         keepAlive: true
                //     },
                // },

                {
                    path: '/home2/index',
                    name: '云称重首页',
                    component: resolve => require(['../views/login/home2index.vue'], resolve),
                    meta: {
                        index: '/home2/index',
                        keepAlive: true
                    },
                },

                {
                    path: '/cloudWeight/userManager',
                    name: '云称重用户管理',
                    component: resolve => require(['../views/cloudWeight/userManager/userManage.vue'], resolve),
                    meta: {
                        index: '/cloudWeight/userManager',
                        keepAlive: true
                    },
                },
                // 云称重
                {
                    path: '/cloudWeight/webWeight',
                    name: '称重操作',
                    component: resolve => require(['../views/cloudWeight/webWeight/index.vue'], resolve),
                    meta: {
                        index: '/cloudWeight/webWeight',
                        keepAlive: true
                    },
                },



                {
                    path: '/count/search',
                    name: '数据查询',
                    component: resolve => require(['../views/cloudWeight/count/dataSearch/index.vue'], resolve),
                    meta: {
                        index: '/count/search',
                        keepAlive: true
                    },
                },
                {
                    path: '/count/statistics',
                    name: '数据统计',
                    component: resolve => require(['../views/cloudWeight/count/statistics.vue'], resolve),
                    meta: {
                        index: '/count/statistics',
                        keepAlive: true
                    },
                }, {
                    path: '/system/setUp',
                    name: '系统设置',
                    component: resolve => require(['../views/cloudWeight/system/systemSetting/setUp.vue'], resolve),
                    meta: {
                        index: '/system/setUp',
                        keepAlive: true
                    },
                }, {
                    path: '/system/unitManage',
                    name: '单位管理',
                    component: resolve => require(['../views/cloudWeight/system/unitManage/index.vue'], resolve),
                    meta: {
                        index: '/system/unitManage',
                        keepAlive: true
                    },
                }, {
                    path: '/system/goodsManage',
                    name: '品名管理',
                    component: resolve => require(['../views/cloudWeight/system/goodsManage/index.vue'], resolve),
                    meta: {
                        index: '/system/goodsManage',
                        keepAlive: true
                    },
                }, {
                    path: '/system/spec',
                    name: '规格管理',
                    component: resolve => require(['../views/cloudWeight/system/specManage/index.vue'], resolve),
                    meta: {
                        index: '/system/spec',
                        keepAlive: true
                    },
                }, {
                    path: '/system/carManage',
                    name: '车辆信息',
                    component: resolve => require(['../views/cloudWeight/system/carManage/index.vue'], resolve),
                    meta: {
                        index: '/system/carManage',
                        keepAlive: true
                    },
                },

            ]
        },


        {
            path: '/home',
            name: '首页',
            component: index,
            iconCls: 'el-icon-tickets',
            children: [{
                path: '/weightCloud/weightIndex',
                name: '用户管理',
                component: resolve => require(['../views/weightCloud/weightIndex/index.vue'], resolve),
                meta: {
                    index: '/weightCloud/weightIndex',
                    keepAlive: true
                },
            }, {
                path: '/weightCloud/weightList',
                name: 'weightCloud/weightList',
                component: resolve => require(['../views/weightCloud/weightList/index.vue'], resolve),
                meta: {
                    index: '/weightCloud/weightIndex',
                    keepAlive: true
                },
            },
            {
                path: '/weightSearch/dataSearch',
                name: 'dataSearch',
                component: resolve => require(['../views/weightSearch/dataSearch/index.vue'], resolve),
                meta: {
                    index: '/weightSearch/dataSearch',
                    keepAlive: true
                },
            },
            {
                path: '/weightSearch/dataSearchNew',
                name: 'dataSearchNew',
                component: resolve => require(['../views/weightSearch/dataSearch/new.vue'], resolve),
                meta: {
                    index: '/weightSearch/dataSearchNew',
                    keepAlive: true
                },
            },
            // 收粮查询

             {
                path: '/weightSearch/dataSearchGrain',
                name: 'dataSearchGrain',
                component: resolve => require(['../views/weightSearch/dataSearchGrain/index.vue'], resolve),
                meta: {
                    index: '/weightSearch/dataSearchGrain',
                    keepAlive: true
                },
            },


            {
                path: '/weightSearch/dataSummary',
                name: 'weightSearch/dataSummary',
                component: resolve => require(['../views/weightSearch/dataSummary/index.vue'], resolve),
                meta: {
                    index: '/weightSearch/dataSummary',
                    keepAlive: true
                },
            },


            {
                path: '/weightSearch/searchUnit',
                name: 'searchUnit',
                component: resolve => require(['../views/weightSearch/searchUnit/index.vue'], resolve),
                meta: {
                    index: '/weightSearch/searchUnit',
                    keepAlive: true
                },
            },
            {
                path: '/weightSearch/dayReport',
                name: 'dayReport',
                component: resolve => require(['../views/weightSearch/dayReport/index.vue'], resolve),
                meta: {
                    index: '/weightSearch/dayReport',
                    keepAlive: true
                },
            },
            {
                path: '/weightSearch/carSummary',
                name: 'carSummary',
                component: resolve => require(['../views/weightSearch/carSummary/index.vue'], resolve),
                meta: {
                    index: '/weightSearch/carSummary',
                    keepAlive: true
                },
            }, {
                path: '/weightSearch/goodsSummary',
                name: 'goodsSummary',
                component: resolve => require(['../views/weightSearch/goodsSummary/index.vue'], resolve),
                meta: {
                    index: '/weightSearch/goodsSummary',
                    keepAlive: true
                },
            }, {
                path: '/weightSearch/deliverSummary',
                name: 'deliverSummary',
                component: resolve => require(['../views/weightSearch/deliverSummary/index.vue'], resolve),
                meta: {
                    index: '/weightSearch/deliverSummary',
                    keepAlive: true
                },
            }, {
                path: '/weightSearch/receiveSummary',
                name: 'receiveSummary',
                component: resolve => require(['../views/weightSearch/receiveSummary/index.vue'], resolve),
                meta: {
                    index: '/weightSearch/receiveSummary',
                    keepAlive: true
                },
            }, {
                path: '/weightSearch/rechargeSummary',
                name: 'rechargeSummary',
                component: resolve => require(['../views/weightSearch/rechargeSummary/index.vue'], resolve),
                meta: {
                    index: '/weightSearch/rechargeSummary',
                    keepAlive: true
                },
            }, {
                path: '/weightSearch/priceSummary',
                name: 'priceSummary',
                component: resolve => require(['../views/weightSearch/priceSummary/index.vue'], resolve),
                meta: {
                    index: '/weightSearch/priceSummary',
                    keepAlive: true
                },
            }, {
                path: '/manage/userManage',
                name: 'manage/userManage',
                component: resolve => require(['../views/manage/userManage/index.vue'], resolve),
                meta: {
                    index: '/manage/userManage',
                    keepAlive: true
                },
            }, {
                path: '/manage/carManage',
                name: '/manage/carManage',
                component: resolve => require(['../views/manage/carManage/index.vue'], resolve),
                meta: {
                    index: '/manage/carManage',
                    keepAlive: true
                },
            }, {
                path: '/manage/trainNumber',
                name: '/manage/trainNumber',
                component: resolve => require(['../views/manage/trainNumber/index.vue'], resolve),
                meta: {
                    index: '/manage/trainNumber',
                    keepAlive: true
                },
            }, {
                path: '/manage/goodsManage',
                name: 'goodsManage',
                component: resolve => require(['../views/manage/goodsManage/index.vue'], resolve),
                meta: {
                    index: '/manage/goodsManage',
                    keepAlive: true
                },
            }, {
                path: '/manage/accountManage',
                name: 'accountManage',
                component: resolve => require(['../views/manage/accountManage/index.vue'], resolve),
                meta: {
                    index: '/manage/accountManage',
                    keepAlive: true
                },
            }, {
                path: '/manage/unitManage',
                name: 'unitManage',
                component: resolve => require(['../views/manage/unitManage/index.vue'], resolve),
                meta: {
                    index: '/manage/unitManage',
                    keepAlive: true
                },
            }, {
                path: '/manage/spec',
                name: 'specManage',
                component: resolve => require(['../views/manage/specManage/index.vue'], resolve),
                meta: {
                    index: '/manage/spec',
                    keepAlive: true
                },
            }, {
                path: '/manage/systemSetting',
                name: 'systemSetting',
                component: resolve => require(['../views/manage/systemSetting/settingOne.vue'], resolve),
                meta: {
                    index: '/manage/systemSetting',
                    keepAlive: true
                },
            },
            {
                path: '/appointmentReview/pendingApproval',
                name: 'pendingApproval',
                component: resolve => require(['../views/appointmentReview/pendingApproval/index.vue'], resolve),
                meta: {
                    index: '/appointmentReview/pendingApproval',
                    keepAlive: true
                },
            },

            {
                path: '/appointmentReview/audited',
                name: 'audited',
                component: resolve => require(['../views/appointmentReview/audited/index.vue'], resolve),
                meta: {
                    index: '/appointmentReview/audited',
                    keepAlive: true
                },
            },

            // 移动端
            {
                path: '/manageIndex',
                name: 'manageIndex',
                component: resolve => require(['../views/mobile/manage/manageIndex.vue'], resolve),
                meta: {
                    index: '/other/index',
                    keepAlive: true
                },
            },

            {
                path: '/weightSearch',
                name: 'weightSearch',
                component: resolve => require(['../views/mobile/weightSearch/weightSearch.vue'], resolve),
            },
            {
                path: '/weightReport',
                name: 'weightReport',
                component: resolve => require(['../views/mobile/weightReport/weightReport.vue'], resolve),
            },


            {
                path: '/manageMine',
                name: 'manageMine',
                component: resolve => require(['../views/mobile/manage/mine/manageMine.vue'], resolve),
                meta: {
                    index: '/other/index',
                    keepAlive: true
                },
            },





            ]
        }
    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js